const resources = { showMore: 'Afficher plus' };

export default function getResource(label) {
    return resources[label];
}
